import type { BookingFilter } from '../models';

export const getCurriculumFilter = (filter: BookingFilter) => {
    const { modules, lessons } = filter;

    return { modules, lessons };
};
